<template> 
    <v-select
      v-model="categoria"
      clearable
      outlined
      return-object
      hide-details
      item-text="nombre"
      :items="items"
      label="Categoria"
      dense></v-select> 
</template>

<script>
import { mapState } from 'vuex';
export default {
  data() {
    return {
      categoria: null,
    };
  },
  watch: {
    categoria(newValue) {
      if (newValue) {
        this.$store.dispatch('categoria/selectCategoria', newValue);
      } else {
        this.$store.dispatch('categoria/setCategoriaNull');
      }
      this.$emit('change', newValue);
    },
  },
  computed: {
    ...mapState({
      items: (state) =>
        state.UNIDAD_NEGOCIO_ID
          ? state.categoria.items.filter((item) => item.unidad_negocio_id == state.UNIDAD_NEGOCIO_ID)
          : [],
      value: (state) => state.categoria.value,
    }),
  },
  mounted() {
    this.categoria = this.value;
  },
};
</script>

<style>
</style>